import { createContext } from 'react'

const PushNotificationContext = createContext({
    permission: 'default'
})

export default PushNotificationContext
